<template>
    <div>
        <!-- 🔼 Header -->
        <div class="slide mb-5" style="margin-top: 74px !important;">
            <div class="bg-img">
                <div class="slide-content">
                    <div>
                        <h2 class="slide-header">{{ 'Scrapping' }}</h2>
                    </div>
                    <div>
                        <h5 class="slide-h5">{{ $t('message.home') }}</h5>
                        <b-icon :icon="isRTL ? 'chevron-double-left' : 'chevron-double-right'" class="icon-slider" />
                        <h5 class="slide-h5">{{ 'Scrapping' }}</h5>
                        <b-icon :icon="isRTL ? 'chevron-double-left' : 'chevron-double-right'" class="icon-slider" />
                        <h5 class="slide-h5">{{ 'Scrapping-details' }}</h5>

                    </div>
                </div>
            </div>
        </div>
        <div class="container mt-4">


            <!-- 🔽 حالة الـ Scrap -->
            <b-alert class="text-center mx-auto" :variant="statusVariant" show
                style="max-width: 350px; font-size: 1.1rem;">
                <b-icon icon="info-circle-fill" class="mr-1" />
                {{ statusLabel }}
            </b-alert>

            <!-- 🟨 الأزرار تظهر فقط إذا الحالة waiting admin (code = 1) -->
            <div v-if="scrapStatus == 1" class="text-center mt-3">
                <b-button variant="success" class="mx-2" @click="updateScrapStatus(5)">
                    <b-icon icon="check-circle" class="mr-1" />
                    Accept
                </b-button>

                <b-button variant="danger" class="mx-2" @click="updateScrapStatus(2)">
                    <b-icon icon="x-circle" class="mr-1" />
                    Refuse
                </b-button>
            </div>

            <!-- زر Completed يظهر فقط عند status === 7 -->
            <div v-if="scrapStatus === 7" class="text-center mb-3">
                <b-button variant="success" @click="markCompleted">
                    <b-icon icon="check-circle-fill" class="mr-1" />
                    Completed
                </b-button>
            </div>

            <h2 class="mb-4 text-primary">
                Scrap Items for ID: {{ scrapId }}
            </h2>


            <b-table responsive striped bordered hover class="invoice-table mt-4 custom-body" :items="scrapItems"
                :fields="fields" :per-page="perPage" :current-page="currentPage" :busy="isLoading">
                <template #table-busy>
                    <div class="text-center my-4">
                        <b-spinner label="Loading..." variant="primary" />
                    </div>
                </template>

                <template #cell(type)="data">
                    <b-badge :variant="data.item.type === '0' ? 'success' : 'danger'">
                        {{ data.item.type === '0' ? 'Sale' : 'Trash' }}
                    </b-badge>
                </template>
                <template #cell(expiry)="data">
                    <span class="font-weight-bold" :class="data.item.expiry === 'yes' ? 'text-success' : 'text-danger'">
                        {{ data.item.expiry === 'yes' ? 'نعم' : 'لا' }}
                    </span>
                </template>


                <template #cell(attachment_security)="data">
                    <a :href="data.item.attachment_security" target="_blank" v-if="data.item.attachment_security">
                        View Attachment
                    </a>
                    <span v-else>-</span>
                </template>

                <!-- 👇 Pagination section -->
                <template #table-caption>
                    <div class="d-flex align-items-center justify-content-between px-2">
                        <div class="d-flex align-items-center">
                            <label class="mr-2 font-weight-bold">Rows per page:</label>
                            <b-form-select :options="perPageOptions" v-model="perPage" @change="onPerPageChange"
                                size="sm" style="width: 100px;" />
                        </div>

                        <b-pagination pills size="sm" class="mb-0" :total-rows="totalRows" v-model="currentPage"
                            :per-page="perPage" @change="changePage" />
                    </div>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>

import axiosInstance from '../axios-config';

export default {
    data() {
        return {
            scrapId: this.$route.params.scrap_id,
            // ⬇️ تفاصيل الـ scrap
            scrapStatus: null,     // 0–8
            // جدول
            scrapItems: [],
            currentPage: 1,
            perPage: 10,
            perPageOptions: [5, 10, 20, 50, 100],
            totalRows: 0,
            isLoading: false,
            fields: [
                { key: 'desc_ar', label: 'اسم الصنف' },
                { key: 'model_number', label: 'الموديل' },
                { key: 'quantity', label: 'الكمية الاجمالية للصنف' },
                { key: 'quantityScrap', label: 'الكمية المخردة' },
                { key: 'type', label: 'النوع' },
                { key: 'uom', label: 'الوحدة' },
                { key: 'manufacture', label: 'بلد المنشأ' },
                { key: 'expiry', label: 'قابلية الانتهاء' },
                { key: 'attachment_security', label: 'مرفق الأمان' }
            ]
        };
    },

    computed: {
        /* نص الحالة */
        statusLabel() {
            const map = {
                0: 'New',
                1: 'Waiting Admin',
                2: 'Cancelled by Admin',
                3: 'Waiting Finance',
                4: 'Cancelled by Finance',
                5: 'Waiting Company',
                6: 'Cancelled by Company',
                7: 'Requester Closed',
                8: 'Completed'
            };
            return map[this.scrapStatus] || 'Unknown';
        },
        /* لون الـ Badge */
        statusVariant() {
            const map = {
                0: 'warning',
                1: 'info',
                2: 'danger',
                3: 'info',
                4: 'danger',
                5: 'info',
                6: 'danger',
                7: 'secondary',
                8: 'success'
            };
            return map[this.scrapStatus] || 'secondary';
        }
    },

    mounted() {
        this.fetchScrapDetails();   // ⬅️ جديد
        this.fetchScrapItems();
    },

    methods: {
        /* ❶ جلب بيانات الـ Scrap (status) */
        async fetchScrapDetails() {
            try {
                const res = await axiosInstance.get(`store/select_scrap_by_id.php?scrap_id=${this.scrapId}`);
                if (res.data.status === 'true') {
                    this.scrapStatus = parseInt(res.data.output.status);
                } else {
                    this.$izitoast.warning({ title: 'Warning', message: res.data.message });
                }
            } catch (err) {
                console.error('Failed to fetch scrap details', err);
            }
        },

        /* ❷ جلب الأصناف (كما كانت) */
        async fetchScrapItems() {
            this.isLoading = true;
            const fd = new FormData();
            fd.append('page', this.currentPage);
            fd.append('page_size', this.perPage);

            try {
                const res = await axiosInstance.post(
                    `store/select_scrap_items.php?scrap_id=${this.scrapId}`,
                    fd
                );

                if (res.data.status === 'true') {
                    this.scrapItems = res.data.output;
                    this.totalRows = parseInt(res.data.pagination.total_products || this.scrapItems.length);
                } else {
                    this.$izitoast.warning({ title: 'Warning', message: res.data.message });
                }
            } catch (err) {
                console.error('Failed to fetch scrap items', err);
                this.$izitoast.error({ title: 'Error', message: 'Error fetching items' });
            } finally {
                this.isLoading = false;
            }
        },

        onPerPageChange() {
            this.currentPage = 1;
            this.fetchScrapItems();
        },

        changePage(val) {
            this.currentPage = val;
            this.fetchScrapItems();
        },

        /* ❸ زر Completed → status = 8 */
        // async markCompleted() {
        //     const fd = new FormData();
        //     fd.append('scrap_id', this.scrapId);
        //     fd.append('status', 8); // Completed

        //     try {
        //         const res = await axiosInstance.post('store/update_scrap_status.php', fd);
        //         if (res.data.status === 'true') {
        //             this.scrapStatus = 8;
        //             this.$izitoast.success({
        //                 title: 'Success',
        //                 message: 'Scrap marked as Completed',
        //                 position: 'bottomLeft'
        //             });
        //         } else {
        //             throw new Error(res.data.message);
        //         }
        //     } catch (err) {
        //         console.error('Error updating status', err);
        //         this.$izitoast.error({ title: 'Error', message: 'Failed to update status', position: 'bottomLeft' });
        //     }
        // },
        async updateScrapStatus(statusCode) {
            try {
                const formData = new FormData();
                formData.append('scrap_id', this.scrapId);  // أو حسب المتغير عندك
                formData.append('status', statusCode);

                const res = await axiosInstance.post('store/update_scrap_status.php', formData);

                if (res.data.status === 'true') {
                    this.$izitoast.success({
                        title: 'Success',
                        message: 'Scrap status updated successfully.',
                        position: 'bottomLeft'
                    });

                    // تحديث الحالة المعروضة
                    this.scrapStatus = String(statusCode);
                } else {
                    throw new Error(res.data.message || 'Update failed.');
                }
            } catch (err) {
                console.error('Error updating status:', err);
                this.$izitoast.error({
                    title: 'Error',
                    message: 'Failed to update scrap status.',
                    position: 'bottomLeft'
                });
            }
        }
    }
};
</script>

<style scoped>
.invoice-table {
    font-size: 14px;
}

.invoice-table {
    font-size: 14px;
}

.perPageSelect {
    border-radius: 6px;
    padding: 4px 10px;
}
</style>
